export const GET_COUNTRIES_REQ = "GET_COUNTRIES_REQ"
export const GET_COUNTRIES_REQ_FAIL = "GET_COUNTRIES_REQ_FAIL"